import AgentChatPageV2 from './AgentChatPageV2'

export default function AgentChatPage() {
  return <AgentChatPageV2 />
}
